
















import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { DomainRegistry } from "../../../domain";
import { ReferenceFileInformation } from "../../../domain/document";
import { ReferenceFileViewMixin } from "../mixins";

@Component
export default class DocumentReferenceFileSelector extends Mixins(ReferenceFileViewMixin) {
  @Prop()
  documentId: number;

  @Prop({ default: null })
  archiveId?: number;

  data(): any {
    return {
      activeNames: [],
      referenceFiles: [],
    };
  }
  activeNames: string[];
  referenceFiles: ReferenceFileInformation[];

  get hasReferenceFile(): boolean {
    return this.referenceFiles.length > 0;
  }

  mounted(): void {
    this.updateReferenceFiles();
  }

  @Watch("documentId")
  onDocumentIdUpdated(newValue: number, oldValue: number): void {
    this.updateReferenceFiles();
  }

  @Watch("archiveId")
  onArchiveIdUpdated(newValue?: number, oldValue?: number): void {
    this.updateReferenceFiles();
  }

  updateReferenceFiles(): void {
    this.referenceFiles = [];
    const repository = DomainRegistry.document.getDocumentRepository();
    repository.getDocumentReferencefiles(this.documentId, this.archiveId)
    .then(d => {
      this.referenceFiles = d;
    }).catch(e => {
      this.$error(
        "参考資料一覧失敗",
        "参考資料一覧を取得できませんでした。",
        e,
      );
    });
  }
}
